import { Container, Gradient, Stream, StreamContainer } from "./styles";

export const VideoContainer = () => {
  return (
    <Gradient>
      <Container>
        <StreamContainer>
          <Stream>
            <iframe
              src="https://www.youtube.com/embed/q1AVP34Qajg?si=yOlIHQn6un5dpw-W"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </Stream>
        </StreamContainer>
      </Container>
    </Gradient>
  );
};
